:host {
    --toujou-slider-progressbar-height: 4px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--toujou-slider-progressbar-height);
    z-index: 1;
}

:host([animated]) {
    animation-name: progressAnimation;
    animation-timing-function: linear;
}

:host([animated][color="primary"]) {
    background-color: var(--primary-color);
}

:host([animated][color="secondary"]) {
    background-color: var(--secondary-color);
}

:host([animated][color="font"]) {
    background-color: var(--font-color);
}

:host([animated][color="grey"]) {
    background-color: var(--font-color--light);
}

:host([animated][animationPaused]) {
    animation-play-state: paused;
}

@keyframes progressAnimation {
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
}
